// extracted by mini-css-extract-plugin
export default {"overlay":"ty-z","bodyOpen":"uy-z","content":"vy-z","header":"wy-z","close":"xy-z","closeNoHeading":"yy-z"};